import { render, staticRenderFns } from "./ProductFollowUp.vue?vue&type=template&id=99fb18b8&"
import script from "./ProductFollowUp.vue?vue&type=script&lang=js&"
export * from "./ProductFollowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports